<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('modules').toUpper() }}</h5>
        <div class="d-flex justify-content-end mb-3" v-if="checkPermission('studentsession_store')">
            <b-button variant="primary" @click="showCreate()">
                {{ $t('new') }}
            </b-button>
        </div>
        <hr v-show="loading"/>
        <div class="position-relative">
            <loading v-show="loading" :description-show="true"/>
            <b-table
                :items="data"
                :fields="computedFields"
                bordered
                striped
                small
                responsive="md"
                sticky-header="60vh"
            >

              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
                <template #cell(actions)="data">
                    <div class="d-flex justify-content-end">
                        <b-dropdown
                        right
                        size="sm"
                        variant="link"
                        toggle-class="p-0"
                        no-caret
                        boundary="window"
                        >
                            <template #button-content>
                                <b-button
                                size="sm"
                                variant="link"
                                class="btn-40 p-0 d-flex align-items-center justify-content-center"
                                >
                                <i class="ri-more-fill"></i>
                                </b-button>
                            </template>

                            <b-dropdown-item
                                v-if="checkPermission('studentsession_update') && data.item.model === 'session'"
                                @click="showUpdate(data.item)"
                            >
                                <i class="ri-pencil-line mr-2"></i>{{ $t('edit') || 'Edit' }}
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="checkPermission('studentsession_delete')"
                                @click="deleteForm(data.item)"
                            >
                                <i class="ri-delete-bin-2-line mr-2"></i>{{ $t('delete') || 'Delete' }}
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="checkPermission('studentdocument_sessionreport') && data.item.model === 'session'"
                                @click="getReport(data.item)"
                            >
                                <i class="ri-mail-download-fill mr-2"></i>Student Report
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="checkPermission('studentdocument_dailysessionattendancelist') && data.item.model === 'session'"
                                @click="studentAttendanceRecordsReport(data.item)"
                            >
                              <i class="ri-mail-download-fill mr-2"></i>Attendance Report
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </template>
                <template #cell(chaperone)="data">
                    <span v-if="data.item.model === 'session'">{{ data.item.chaperone_name }}</span>
                </template>
                <template #cell(comment)="data">
                    <b-button
                        v-if="data.item.comment"
                        size="sm"
                        variant="outline-info"
                        class="btn-40"
                        @click="openCommentModal(data.item.comment)"
                    >
                        <i class="ri-eye-line"></i>
                    </b-button>
                </template>
                <template #cell(conditionally_passed)="data">
                    <template v-if="data.item.model === 'session'">
                        <yes-no-selectbox
                            v-if="false && !data.item.passed && checkPermission('studentsession_update')"
                            class="width-60"
                            v-model="data.item.conditionally_passed"
                            @input="updateConditionallyPassed(data.item)"
                        />
                        <b-badge v-if="!checkPermission('studentsession_update') || data.item.passed"
                                 :variant="data.item.conditionally_passed===true ? 'success' : 'danger'">
                            {{ data.item.conditionally_passed===true ? 'Yes' : 'No' }}
                        </b-badge>
                        <b-badge v-else :variant="data.item.conditionally_passed===true ? 'success' : 'danger'"
                        class="cursor-pointer" @click="updateConditionallyPassed(data.item)">
                            {{ data.item.conditionally_passed===true ? 'Yes' : 'No' }}
                        </b-badge>
                    </template>
                </template>
                <template #cell(passed)="data">
                    <b-badge v-if="data.item.model === 'session'" :variant="data.item.passed==true ? 'success' : 'danger'">
                        {{ data.item.passed===true ? 'Yes' : 'No' }}
                    </b-badge>
                </template>
                <template #cell(is_paid)="data">
                    <b-badge v-if="data.item.model === 'session'" :variant="data.item.is_paid===true ? 'success' : 'danger'">
                        {{ data.item.is_paid===true ? 'Yes' : 'No' }}
                    </b-badge>
                </template>
                <template #cell(approval_status)="data">
                    <b-badge v-if="data.item.model === 'session'" :variant="data.item.approval_status==='Registration Completed' ? 'success' : 'danger'">
                        {{ data.item.approval_status}}
                    </b-badge>
                </template>
            </b-table>

        </div>
        <CommonModal ref="modal" size="lg" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                <div>{{ formProcess === 'createForm' ? $t('create') : $t('update') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <CreateForm v-if="formProcess==='createForm'" @successCreate="successCreate"
                            :studentProgram="studentProgram"/>
                <UpdateForm v-if="formProcess==='updateForm'" :studentProgram="studentProgram"
                            @successCreate="successCreate" :formId="formId"/>
            </template>
        </CommonModal>
        <CommonModal ref="commentModal" size="md" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('comment') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <div>
                    {{ currentComment }}
                </div>
            </template>
        </CommonModal>
    </div>
</template>
<script>
// Component
import Loading from '@/components/elements/Loading';
import CommonModal from "@/components/elements/CommonModal.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
// Service
import StudentSessionService from "@/services/StudentSessionService";
import CreateForm from "@/modules/students/pages/student/sessions/CreateForm.vue";
import UpdateForm from "@/modules/students/pages/student/sessions/UpdateForm.vue"
import qs from "qs";
import StudentTimeOfServices from "@/services/StudentTimeOfServices";
import {EventBus} from "@/main";
import StudentDocumentService from "@/services/StudentDocumentService";
import showErrors from "@/helpers/showErrors";
export default {
    components: {
        CreateForm,
        CommonModal,
        YesNoSelectbox,
        Loading,
        UpdateForm,
    },
    props: {
        studentProgram: {
            type: Object,
            default: null
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            data: [],
            formProcess: null,
            fields: [
                { key: "actions", label: "", tdClass: "text-right" },
                { key: "index", label: "#"},
                { key: "course_name", label: this.$t("course_name") },
                { key: "start_date", label: this.$t("start_date") },
                { key: "end_date", label: this.$t("end_date") },
                { key: "instructor", label: this.$t("instructor") },
                { key: "chaperone", label: this.$t("chaperone"), summerYouthOnly: true },
                { key: "score", label: this.$t("score"), summerYouthHidden: true },
                { key: "total_absences", label: this.$t("absences"), summerYouthHidden: true },
                { key: "passed", label: this.$t("passed") },
                { key: "conditionally_passed", label: this.$t("conditionally_passed"), summerYouthHidden: true },
                { key: "approval_status", label: this.$t("approval_status"), summerYouthHidden: true },
                { key: "is_paid", label: this.$t("paid") },
                { key: "comment", label: this.$t("comment"), summerYouthHidden: true },
            ],
            editingId: null,
            showCommentModal: false,
            loading: false,
            formId: null,
            currentComment: '',
        }
    },
    mounted() {
        this.getRows()
    },
    computed: {
        isSummerYouth() {
            return this.studentProgram?.program_code === '0702004';
        },
        computedFields() {
            const showActions=this.checkPermission('studentsession_delete')
                || this.checkPermission('studentsession_update')
                || this.checkPermission('studentdocument_dailysessionattendancelist')
                || this.checkPermission('studentdocument_sessionreport');
            const isSummerYouth = this.isSummerYouth;
            return this.fields.filter(function (field) {
                if(field.key=='actions'){
                    return showActions;
                }
                if(field.summerYouthHidden && isSummerYouth){
                    return false;
                }
                if(field.summerYouthOnly && !isSummerYouth){
                    return false;
                }
                return true;
            });
        }
    },
    methods: {
        showCreate() {
            this.formProcess = 'createForm';
            this.$refs.modal.$refs.commonModal.show()
        },
        async getRows() {
            // this.datatable.showTable = true
            // this.datatable.isLoading = true
            const config={
                params:{
                    limit:-1
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})

            }

            StudentSessionService.sessionAndTimeOffs(this.studentProgram.id,config)
                .then(response => {
                    this.data = response.data.data;
                })
                .catch((e) => {
                    this.showErrors(e)
                })
                // .finally(this.datatable.isLoading = false)
        },
        deleteForm({id,model}) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        if (['session'].includes(model)) {
                            StudentSessionService.del(id)
                                .then(response => {
                                    this.$toast.success(this.$t('api.' + response.data.message))
                                    this.getRows()
                                })
                                .catch(error => {
                                    this.$toast.error(this.$t('api.' + error.data.message))
                                })
                        }
                        if (['time_off'].includes(model)) {
                            StudentTimeOfServices.del(id)
                                .then(response => {
                                    this.$toast.success(this.$t('api.' + response.data.message))
                                    this.getRows()
                                })
                                .catch(error => {
                                    this.$toast.error(this.$t('api.' + error.data.message))
                                })
                        }


                    }
                })
        },
        getReport(item) {
            const config ={
                params: {
                    response_type:'pdf'
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false })
            }
            config.responseType = 'arraybuffer';
            StudentSessionService.getStudentReport(item.id,config)
                .then((response) => {
                  let fileName = item.course_name+' - Student Report' + '.pdf'
                  EventBus.$emit('pdfViewerModalShow', {
                    pdfFileData: response.data,
                    pdfFileName: fileName
                  });
                  this.processing = false
                })
        },
        async studentAttendanceRecordsReport(item) {

          StudentDocumentService.studentDailySessionPdf(item.id)
              .then(response=>{
                let fileName = item.course_name+' - Attendance Report' + '.pdf'
                EventBus.$emit('pdfViewerModalShow', {
                  pdfFileData: response.data,
                  pdfFileName: fileName
                });
              }).catch(e => {
            showErrors(e, null, true)
          })
        },
        async successCreate() {
            await this.getRows()
            this.formProcess = null
            this.$refs.modal.$refs.commonModal.hide()

        },
        showUpdate(item) {
            this.formId = item.id;
            this.formProcess = 'updateForm';
            this.$refs.modal.$refs.commonModal.show();
        },
        updateConditionallyPassed(item) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_update'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StudentSessionService.update(item.id, {conditionally_passed: item.conditionally_passed ? 0 : 1})
                            .then(response => {
                                this.$toast.success(this.$t("api." + response.data.message));
                                item.conditionally_passed=!item.conditionally_passed;
                            }).catch(error=>{
                            this.$toast.error(
                                this.$t("api." + error.data.message)
                            );
                        })
                    }
                })
        },
        openCommentModal(comment) {
            this.currentComment = comment || '';
            this.$refs.commentModal.$refs.commonModal.show();
        }
    }
}
</script>
<style>
th, th div {
    white-space: break-spaces !important;
}
</style>
